import { cx } from '@emotion/css'
import React, { useEffect, useRef } from 'react'

type CoralCommentCountProps = {
    articleURL: string
    className?: string
}

export const CoralCommentCount = ({
    articleURL,
    className,
}: CoralCommentCountProps) => {
    const isLoaded = useRef(false)

    // Reload coral count on render. (Trigger coral's script)
    useEffect(() => {
        if (isLoaded.current) return

        window.CoralCount && window.CoralCount.reload()
        isLoaded.current = true
    }, [])

    return (
        <span
            className={cx(className, `coral-count`)}
            data-coral-url={articleURL}
            data-coral-notext={true}
            dangerouslySetInnerHTML={{
                __html: '',
            }} // Bypass hydration overwriting the span
            suppressHydrationWarning
        />
    )
}
